export enum CampaignType {
  UNSET_CAMPAIGN_TYPE = 'UNSET_CAMPAIGN_TYPE', // Do not use, needed because of proto3 limitations
  DATABACK = 'DATABACK',
  APPINSTALL = 'APPINSTALL',
  PORTING = 'PORTING',
  SURVEY = 'SURVEY',
  SKU = 'SKU',
  MANUAL = 'MANUAL',
}
